var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dictToArray } from '../objects';
import { powerZoneDefinitions } from '../user';
// blocks without a valid target are set to 75% CP
var getDefaultIntensity = function () {
    return {
        value: 75,
        min: 70,
        max: 80
    };
};
// Zones are taken from training_zones in the User object
// segment min/max equals the zone power_low/power_high
// segment target equals the average of min/max
// if the zone index is greater than the number of zones, use the last zone
// if the user doesn’t have zones or a CP, fallback to hardcoded zones
var defaultPercentZones = dictToArray(powerZoneDefinitions).map(function (zone) {
    var percentHigh = zone.percentHigh, percentLow = zone.percentLow, title = zone.title;
    return {
        name: title,
        power_low: percentLow,
        power_high: percentHigh,
        speed_low: 0,
        speed_high: 0
    };
});
var wattsToPercentCp = function (cp) { return function (watts) {
    if (!cp)
        return getDefaultIntensity().value;
    return (watts / cp) * 100;
}; };
var zoneToPercentTargets = function (cp, zone) {
    var power_low = zone.power_low, power_high = zone.power_high;
    var toUserPercent = wattsToPercentCp(cp);
    var targetPower = (power_low + power_high) / 2;
    var targetPercent = toUserPercent(targetPower);
    var min = toUserPercent(power_low);
    var max = toUserPercent(power_high);
    return {
        value: targetPercent,
        min: min,
        max: max
    };
};
/**
 * Convert a zone to a target percentage of CP
 */
var zoneToTargetIntensity = function (trainingInfo, zoneIndex) {
    var trainingZones = trainingInfo.trainingZones, cp = trainingInfo.cp;
    var defaultZones = defaultPercentZones.map(function (zone) { return (__assign(__assign({}, zone), { power_low: (zone.power_low / 100) * cp, power_high: (zone.power_high / 100) * cp })); });
    var zones = trainingZones || defaultZones;
    var index = zoneIndex > zones.length - 1 ? zones.length - 1 : zoneIndex;
    return zoneToPercentTargets(cp, zones[index]);
};
var rpeToTargetIntensity = function (rpe) {
    switch (rpe) {
        case 1:
            return { min: 63, value: 65, max: 67 };
        case 2:
            return { min: 68, value: 70, max: 72 };
        case 3:
            return { min: 73, value: 75, max: 77 };
        case 4:
            return { min: 78, value: 80, max: 82 };
        case 5:
            return { min: 83, value: 85, max: 87 };
        case 6:
            return { min: 88, value: 90, max: 92 };
        case 7:
            return { min: 98, value: 100, max: 102 };
        case 8:
            return { min: 113, value: 115, max: 117 };
        case 9:
            return { min: 128, value: 130, max: 132 };
        case 10:
            return { min: 148, value: 150, max: 152 };
        default: {
            var _exhaustiveCheck = rpe;
            return { min: 75, max: 75, value: 75 };
        }
    }
};
/**
 * Extract the %CP target from a Workout Segment, accounting for pace or zone segments as well.
 *
 * pace segments will return a value of 0% and are currently unsupported.
 */
export var getSegmentIntensity = function (trainingInfo, segment) {
    var intensity_type = segment.intensity_type, intensity_percent = segment.intensity_percent, zone_selected = segment.zone_selected, rpe_selected = segment.rpe_selected;
    switch (intensity_type) {
        case 'percentage':
            return intensity_percent
                ? segment.intensity_percent
                : getDefaultIntensity();
        case 'zone':
            return zone_selected !== undefined
                ? zoneToTargetIntensity(trainingInfo, zone_selected)
                : getDefaultIntensity();
        case 'pace':
            return getDefaultIntensity();
        case 'rpe':
            return rpeToTargetIntensity(rpe_selected);
        default:
            var _exhaustiveCheck = intensity_type;
            return getDefaultIntensity();
    }
};
//# sourceMappingURL=getSegmentIntensity.js.map